import { defineStore } from 'pinia';
import { useFetch } from '../../../composables/useFetch';
import { IFilterGroup, IRidingSchool } from '../model/ridingschool.models';

interface IState {
    error: boolean;
    filters: IFilterGroup[];
    filterOverlayIsOpen: boolean;
    loading: boolean;
    page: number;
    query: string | null;
    results: IRidingSchool[];
    resetComponentState: boolean;
    searchParams: URLSearchParams | null;
    searchUrl: string | null;
    totalItems: number;
    url: URL | null;
}

export const useRidingschoolStore = defineStore('ridingschoolStore', {
    state: (): IState => {
        return {
            error: false,
            filters: [],
            filterOverlayIsOpen: false,
            loading: false,
            page: 0,
            query: '',
            results: [],
            resetComponentState: false,
            searchParams: null,
            searchUrl: null,
            totalItems: 0,
            url: null,
        };
    },
    getters: {},
    actions: {
        clearSearchParams() {
            this.$state.results = [];
            this.$state.searchParams = new URLSearchParams();
            this.$state.searchUrl = null;
            this.$state.query = '';
            this.$state.resetComponentState = this.reset();
        },
        reset() {
            if (this.$state.resetComponentState === false) {
                return true;
            }
            return false;
        },
        incrementPage() {
            this.$state.page = this.$state.page + 1;
        },
        setFilters(filters: IFilterGroup[]) {
            this.$state.filters = filters;
        },
        setPage(page: number) {
            this.$state.page = page;
        },
        setSearchQuery(item: string | null) {
            this.$state.query = item;
        },
        toggleFilterOverlay() {
            this.$state.filterOverlayIsOpen = !this.$state.filterOverlayIsOpen;
        },
        async fetchSearchResults(searchUrl: string) {
            this.loading = true;
            try {
                const { data, error, isLoading } = await useFetch(
                    `/umbraco/api/searchapi/GetRidingSchoolResults${
                        searchUrl ? '?' + searchUrl : ''
                    }`
                );

                if (data.value) {
                    this.results = data.value.items;
                    this.totalItems = data.value.totalItems;
                } else {
                    this.results = [];
                    this.totalItems = 0;
                }

                //this.page = 1;
                this.error = error.value;
                this.loading = isLoading.value;
            } catch (error) {
                console.error('[ERROR]:', error);
            }
        },
        async loadMore(searchUrl: string) {
            try {
                const { data, error, isLoading } = await useFetch(
                    `/umbraco/api/searchapi/GetRidingSchoolResults${
                        searchUrl ? '?' + searchUrl : ''
                    }`
                );

                if (data.value) {
                    this.results.push(...data.value.items);
                } else {
                    this.results = [];
                }

                this.error = error.value;
                this.loading = isLoading.value;
            } catch (error) {
                console.error('[ERROR]:', error);
            }
        },
    },
});
